import { KLayout } from "@/pages/kreonis/KLayout";
import { Seo } from "@/components/Seo";
import { Hexagon } from "lucide-react";

export default function KOnboardingEmail() {
  return (
    <KLayout>
      <Seo title="KREONIS — Welcome Email Preview" />
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
        <h1 className="font-display text-2xl font-bold text-slate-50">Welcome Email Preview</h1>
        <p className="mt-1 text-sm text-slate-500">Automatically sent to every new allocator upon registration.</p>

        <div className="mt-6 overflow-hidden rounded-2xl border border-slate-800 bg-white text-slate-800 shadow-2xl" data-testid="kemail-preview">
          <div className="border-b border-slate-200 px-6 py-3 text-xs text-slate-500">
            <div><span className="font-semibold text-slate-700">From:</span> KREONIS Intelligence &lt;intelligence@kreonis.com&gt;</div>
            <div><span className="font-semibold text-slate-700">Subject:</span> Welcome to KREONIS: Your Institutional Access is Active</div>
          </div>
          <div className="px-8 py-8">
            <div className="flex items-center gap-2">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-100"><Hexagon className="h-5 w-5 text-emerald-600" /></div>
              <span className="font-display text-lg font-extrabold tracking-[0.2em] text-slate-900">KREONIS</span>
            </div>
            <div className="mt-6 space-y-4 text-sm leading-relaxed text-slate-600">
              <p>Dear Allocator,</p>
              <p>Welcome to KREONIS. Your secure access to our institutional-grade AI Market Intelligence architecture has been successfully provisioned.</p>
              <p className="font-semibold text-slate-800">Here is how to initiate your workflow today:</p>
              <ul className="list-disc space-y-1.5 pl-5">
                <li><b>Explore the Intel Feed:</b> Isolate non-correlated predictive signals.</li>
                <li><b>Run Macro Analytics:</b> Evaluate current structural trends and volatility frameworks.</li>
                <li><b>Simulated Allocation:</b> Test your models with $100,000 in virtual capital before exposing live funds.</li>
              </ul>
              <p>Our core objective is simple: to help you understand markets, find signals, and manage risk with absolute clarity.</p>
              <div className="py-2"><a href="/kreonis" className="inline-block rounded-lg bg-emerald-600 px-6 py-3 font-semibold text-white no-underline">Go to Dashboard</a></div>
              <p>If you have any technical inquiries or require custom API integrations, reply directly to this email.</p>
              <p className="text-slate-700">Regards,<br />The KREONIS Engineering Team</p>
            </div>
          </div>
          <div className="border-t border-slate-200 px-8 py-4 text-xs text-slate-400">kreonis.ai &nbsp;|&nbsp; kreonis.io</div>
        </div>
      </div>
    </KLayout>
  );
}
